import React, { useState } from "react";
import { CreateNews } from "../../pages";
import * as yup from "yup";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import { NewsController } from "../../controllers";
import { adminStore } from "../../stores";
import { handleImageUpload } from "../../utils/utils";

const CreateNewsContainer = ({ closeModal, data }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      title: yup.string().required("Enter News title"),
      text: yup.string().required("Enter News content"),
      summary: yup.string().required("Enter News summary"),
      imageUrls: yup.array(
        yup.object({
          key: yup.string().required("Enter Image name"),
        })
      ),
      action: yup.object({
        url: yup.string("Enter action url"),
        buttonTitle: yup.string("Enter action title"),
      }),
    });
  };

  const singleNews = adminStore.singleNews;
  const isCopied = Object.keys(singleNews).length > 0;

  const singleNewsImageUrls = singleNews?.imageUrls?.map((x) => {
    return {
      key: x.key,
      url: x.url,
    };
  });

  const onSubmit = async (values) => {
    if (values.imageUrls[0].files.length < 1) {
      return MimaToastUtil.error({
        message: "Kindly add at least 1 image",
      });
    }

    setLoading(true);

    const file = values.imageUrls?.[0]?.files?.[0];

    let fileUrls = [file?.preview];
    if (file?.name !== file?.preview) {
      fileUrls = await handleImageUpload(values.imageUrls?.[0]?.files);
    }

    const id = singleNews._id;

    const payload = {
      title: values.title,
      text: values.text,
      summary: values.summary,
      imageUrls: isCopied
        ? singleNewsImageUrls
        : [
            {
              key: values.imageUrls[0].key,
              url: fileUrls[0],
            },
          ],

      action: values.action,
    };

    if (isCopied) {
      const { status, errorMessage } = await NewsController.updateNews(
        payload,
        id
      );
      if (status === constant.Success) {
        MimaToastUtil.success({ message: constant.Success });
        setLoading(false);
        return closeModal();
      } else {
        setLoading(false);
        MimaToastUtil.error({ message: errorMessage });
      }
    } else {
      const { status, errorMessage } = await NewsController.createNews(payload);
      if (status === constant.Success) {
        MimaToastUtil.success({ message: constant.Success });
        setLoading(false);
        return closeModal();
      } else {
        setLoading(false);
        MimaToastUtil.error({ message: errorMessage });
      }
    }
  };
  return (
    <CreateNews
      validationSchema={validationSchema}
      loading={loading}
      closeModal={closeModal}
      data={data}
      onSubmit={onSubmit}
      singleNews={singleNews}
      isCopied={isCopied}
    />
  );
};
export default CreateNewsContainer;
